module.exports = __webpack_public_path__ + "assets/img/img337.dbc5d502.png";